/**
 * life/src/lib/mode.ts — demo/live mode resolution.
 *
 * 'demo': fixtures behind the same hooks, writes held in-memory for the
 *         session, persistent badge visible. Sign-in still required.
 * 'live': /api/life/* for real.
 *
 * Anything other than the literal 'live' resolves to demo — the honest
 * default is the one that never shows fake data as real.
 */

export type LifeMode = "demo" | "live";

export function resolveMode(raw: string | undefined): LifeMode {
  return raw === "live" ? "live" : "demo";
}

export const LIFE_MODE: LifeMode = resolveMode(import.meta.env?.VITE_LIFE_MODE);

export const IS_DEMO = LIFE_MODE === "demo";
